const sortArrayOfDateObjectsAsc = (array, key) => {
  return array.sort((a, b) => new Date(a[key]) - new Date(b[key]));
};

const sortArrayOfDateObjectsDesc = (array, key) => {
  return array.sort((a, b) => new Date(b[key]) - new Date(a[key]));
};

const sortArrayOfStringObjectsAsc = (array, key) => {
  return array.sort((a, b) => a[key].localeCompare(b[key]));
};

const sortArrayOfNumbersAsc = (array, key) => {
  return array.sort((a, b) => a[key] - (b[key]));
};

const sortArrayOfNumbersDesc = (array, key) => {
  return array.sort((a, b) => b[key] - (a[key]));
};

const sortArrayOfStringObjectsByValueAsc = (array, key, value) => {
  if (value) {
    const sortedArray = [
      ...array.filter(item => item[key] === value),
      ...array.filter(item => item[key] != value)
    ];
    return sortedArray;
  } else {
    return array;
  }
};

export {
  sortArrayOfDateObjectsAsc,
  sortArrayOfDateObjectsDesc,
  sortArrayOfStringObjectsAsc,
  sortArrayOfNumbersAsc,
  sortArrayOfNumbersDesc,
  sortArrayOfStringObjectsByValueAsc
};